import type {PullRequestFileTreeDiff} from '../page-data/payloads/file-tree'
import type {ProgressiveDiffEntry, ProgressiveDiffEntriesState} from '../types/progressive-diff-types'

export function buildProgressiveDiffEntries({
  diffSummaries,
  loadedPathDigests,
}: {
  diffSummaries: Record<string, PullRequestFileTreeDiff>
  loadedPathDigests: Set<string>
}): ProgressiveDiffEntriesState {
  const entriesMap: Record<string, ProgressiveDiffEntry> = {}
  const entriesOrder: string[] = []

  for (const summary of Object.values(diffSummaries)) {
    const {path, pathDigest} = summary
    const isLoaded = loadedPathDigests.has(pathDigest)

    entriesMap[pathDigest] = {
      path,
      pathDigest,
      isLoaded,
    }
    entriesOrder.push(pathDigest)
  }

  return {entriesMap, entriesOrder}
}
